<div id="route-container">
    <router-outlet></router-outlet>
</div>
